<template>
  <div class="mt-8">
    <px-view-module-header module-name="Marketplace" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Edição rápida">
          <template v-slot:before>
            <v-btn class="mb-1 mr-1" icon x-large color="primary" @click="onClickBack">
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
        </px-view-header-title>
        <px-oferta-edicao-rapida-header @refresh="onClickRefresh"
                                        @change="onChangeFilter"/>
        <v-alert type="warning" dismissible outlined class="mt-3 rounded-card">
          Na edição rápida é permitido editar apenas ofertas que <b>não possuem variação</b>.
        </v-alert>
        <div v-if="loading">
          <px-circular-loading/>
        </div>
        <div v-if="!loading && ofertas.content && ofertas.content.length">
          <span v-for="item in ofertas.content" :key="item.id">
            <px-oferta-edicao-rapida-item :oferta="item"/>
          </span>
        </div>
        <v-pagination
          class="mt-10"
          v-model="page"
          :length="pagesLimit"
          :total-visible="5"
        ></v-pagination>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import OfertaEdicaoRapidaHeader from './OfertaEdicaoRapidaHeader.vue';
import OfertaService from '../oferta-service';
import OfertaEdicaoRapidaItem from './OfertaEdicaoRapidaItem.vue';

const LIMIT = 20;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Marketplace' },
        {
          text: 'Ofertas',
          to: '/marketplace/ofertas',
        },
        { text: 'Edição rápida' },
      ],
      loading: false,
      page: PAGE,
      pagesLimit: 1,
      ofertas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: PAGE,
        limit: LIMIT,
        offset: 0,
        filter: '',
        sort: 'titulo',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemMarketplaceOfertas', ['stringFilter']),
  },
  methods: {
    buildFilter() {
      if (this.stringFilter) {
        return `${this.stringFilter} and possuiVariacao is false`;
      }
      return 'possuiVariacao is false';
    },
    onClickBack() {
      this.$router.push({ name: 'main.marketplace.ofertas' });
    },
    onChangeFilter() {
      this.listOptions.filter = this.buildFilter();
      this.resetPage();
      this.getOfertas();
    },
    onChangeOptions() {
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getOfertas();
    },
    onClickRefresh() {
      this.getOfertas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.ofertas.total / LIMIT);
    },
    getOfertas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      return OfertaService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.ofertas = response.data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.buildFilter();
    this.getOfertas();
  },
  components: {
    pxOfertaEdicaoRapidaHeader: OfertaEdicaoRapidaHeader,
    pxOfertaEdicaoRapidaItem: OfertaEdicaoRapidaItem,
  },
};
</script>
